import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import firebase from 'firebase';

import { withStyles } from 'material-ui/styles';
import PropTypes from 'prop-types';

import getQueryVariable from './getQueryVariable';

class LoginView extends Component {

  componentWillMount() {
    if (firebase.auth().currentUser) {
      this.onSignIn(firebase.auth().currentUser);
    } else {
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  redirect = () => {
    var next = getQueryVariable("next") || this.next;
    console.log(window.location);

    var new_location = '';
    if (next) {
      new_location = next;
    } else {
      new_location = '/';
      console.log(window.location);
    }

    this.props.history.push(new_location);
  }


  onSignIn = (user) => {
    this.redirect();
  }

  render() {
    const classes = this.props.classes;
    return (
      <div>
      </div>
    );
  }
}

LoginView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(LoginView);



// WEBPACK FOOTER //
// ./src/LoginView.js